import image from "../assets/images/visionmission.png";

function VisionMission() {
  return (
    <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8 mt-8">

      {/* Text Content */}
      <div className="md:w-2/3 text-[#05326D]">

          <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
            <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
            Vision
          </h2>

        <div className="flex items-start gap-3 mb-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 mt-2 flex-shrink-0"></div>
          <p>
            To be a globally trusted partner in life sciences—empowering pharmaceutical, biotech, medical device, and nutraceutical companies to achieve regulatory excellence, accelerate innovation, and improve patient outcomes across borders.
          </p>
        </div>

        <div className="flex items-start gap-3 mb-8">
          <div className="w-2 h-2 rounded-full bg-sky-300 mt-2 flex-shrink-0"></div>
          <p>
            We envision a world where compliance is seamless, approvals are accelerated, and every product reaches the market with integrity, safety, and purpose.
          </p>
        </div>
         <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
            <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
            Mission
          </h2>

        {[
          "To deliver end-to-end regulatory, clinical, quality, and pharmacovigilance solutions that are tailored, timely, and globally compliant.",
          "To support our clients in navigating complex regulatory landscapes with clarity, confidence, and strategic foresight.",
          "To uphold the highest standards of data integrity, ethical conduct, and operational transparency.",
          "To foster long-term partnerships by aligning our expertise with our clients’ growth, innovation, and market expansion goals.",
          "To continuously evolve through digital transformation, global insights, and multidisciplinary collaboration.",
        ].map((text, index) => (
          <div key={index} className="flex items-start gap-3 mb-3">
            <div className="w-2 h-2 rounded-full bg-sky-300 mt-2 flex-shrink-0"></div>
            <p>{text}</p>
          </div>
        ))}
      </div>

      {/* Image Content */}

      <img
        src={image}
        alt="Vision and Mission Rocket"
        className="w-full max-w-[250px] md:max-w-[300px]"
      />

    </div>
  );
}

export default VisionMission;
